import { ptBR } from 'date-fns/locale'
import { format } from 'date-fns'

export const dataHoraAtual = () => {
    const dataAtual = new Date()
    return dateHourAsString(dataAtual)
}

export const dateHourAsString = (date) => {
    return format(date, 'dd/MM/yyyy_HH:mm:ss', { locale: ptBR })
}
